import { render } from "./CheckInPage.vue?vue&type=template&id=2b99d960&scoped=true"
import script from "./CheckInPage.vue?vue&type=script&lang=js"
export * from "./CheckInPage.vue?vue&type=script&lang=js"

import "./CheckInPage.vue?vue&type=style&index=0&id=2b99d960&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b99d960"]])

export default __exports__